import React from 'react'
import { useMotionPreferences } from '../../../context/MotionPreferencesContext'
import styles from './MotionToggle.module.css'

/**
 * Motion Toggle Button
 *
 * A small, unobtrusive toggle that allows users to enable/disable
 * background animations. Placed in the footer or as a floating button.
 *
 * Features:
 * - Respects and overrides system prefers-reduced-motion
 * - Persists choice in localStorage
 * - Accessible with proper ARIA labels
 */

const MotionToggle = ({ className = '', variant = 'default' }) => {
  const { reducedMotion, toggleMotion, source } = useMotionPreferences()

  return (
    <button
      className={`${styles.toggle} ${styles[variant]} ${className}`}
      onClick={toggleMotion}
      aria-pressed={!reducedMotion}
      aria-label={reducedMotion ? 'Enable animations' : 'Reduce animations'}
      title={reducedMotion ? 'Enable animations' : 'Reduce animations'}
    >
      <span className={styles.iconWrapper}>
        {reducedMotion ? (
          // Paused/static icon
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="6" y="4" width="4" height="16" rx="1" />
            <rect x="14" y="4" width="4" height="16" rx="1" />
          </svg>
        ) : (
          // Animated/playing icon
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        )}
      </span>
      <span className={styles.label}>
        {reducedMotion ? 'Motion off' : 'Motion on'}
      </span>
      {source === 'system' && (
        <span className={styles.badge}>Auto</span>
      )}
    </button>
  )
}

export default MotionToggle
